<template>
  <FreeSwitch
    :checked="checked"
    :disabled="disabled"
    class="w-full flex-row-reverse"
    @onChange="
      emit('onNightTransferFilterChange', !state.isWithoutNightTransfer)
    "
  >
    <template #labelText>
      <p class="text-text-neutral-primary font-medium">
        {{ $t('search.filters.withoutNightTransfers') }}
      </p>
    </template>
  </FreeSwitch>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { isNil } from 'lodash-es';
  import { FreeSwitch } from 'freedom-shared';
  import type { FilterState } from '@aviata/offers-filters-fns';

  const emit = defineEmits<{
    onNightTransferFilterChange: [isActive: boolean];
  }>();

  const props = defineProps<{
    state: FilterState & { isWithoutNightTransfer: boolean };
  }>();

  const checked = computed(
    () =>
      props.state.isWithoutNightTransfer &&
      props.state.flights[0].transfers[0] !== 0,
  );
  const disabled = computed(
    () =>
      isNil(props.state.isWithoutNightTransfer) ||
      props.state.flights[0].transfers[0] === 0,
  );
</script>
